/**
 * @license @tabler/icons-vue v3.34.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createVueComponent from '../createVueComponent.mjs';

var IconFileDislike = createVueComponent("outline", "file-dislike", "IconFileDislike", [["path", { "d": "M3 14m0 1a1 1 0 0 1 1 -1h1a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-1a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M6 15a1 1 0 0 1 1 -1h3.756a1 1 0 0 1 .958 .713l1.2 3c.09 .303 .133 .63 -.056 .884c-.188 .254 -.542 .403 -.858 .403h-2v2.467a1.1 1.1 0 0 1 -2.015 .61l-1.985 -3.077v-4z", "key": "svg-1" }], ["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-2" }], ["path", { "d": "M5 11v-6a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2h-2.5", "key": "svg-3" }]]);

export { IconFileDislike as default };
//# sourceMappingURL=IconFileDislike.mjs.map
